import { render, staticRenderFns } from "./EmploymentsChart.vue?vue&type=template&id=5ebf8b48&scoped=true&"
import script from "./EmploymentsChart.vue?vue&type=script&lang=js&"
export * from "./EmploymentsChart.vue?vue&type=script&lang=js&"
import style0 from "./EmploymentsChart.vue?vue&type=style&index=0&id=5ebf8b48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf8b48",
  null
  
)

export default component.exports